<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <div class="level_picker_content d-flex-column justify-start align-start">
      <div class="d-flex-row space-between md-row-to-col">
        <StadiumRank
          :title="$t('order_details.currentRank')"
          :description="$t('select_current_rank')"
          :ranks="ranks"
          :type="'currentRank'"
        />
        <StadiumRank
          :title="$t('order_details.desiredRank')"
          :description="$t('select_desired_rank')"
          :ranks="ranks"
          :type="'desiredRank'"
          :prev-rank="checkoutStore.getDetails.currentRankSlab"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import StadiumRank from "./StadiumRank.vue";
const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();

const ranks = computed(() => {
  return gameStore.getGamePack?.prices;
});
</script>
